<template>
  <Modal
    v-model="_value"
    width="500"
    title="HIK设置夜间行驶时长"
    @on-visible-change="visibleChange"
    ok-text="关闭"
    cancel-text="">
    <Form ref="setDriverCardParamsRef" v-model="setTravelTime" :label-width="90">
      <FormItem prop="driverCardNum" label="开启夜间使能">
        <checkbox v-model="setTravelTime.enabled">
        </checkbox>
      </FormItem>
      <FormItem prop="driverLicenseNum" label="开始时间">
        <InputNumber :max="23" :min="0" v-model="setTravelTime.bHour"></InputNumber>
        <InputNumber :max="59" :min="0" v-model="setTravelTime.bMin"></InputNumber>
        <InputNumber :max="59" :min="0" v-model="setTravelTime.bSec"></InputNumber>
      </FormItem>
      <FormItem prop="driverName" label="结束时间">
        <InputNumber :max="23" :min="0" v-model="setTravelTime.eHour"></InputNumber>
        <InputNumber :max="59" :min="0" v-model="setTravelTime.eMin"></InputNumber>
        <InputNumber :max="59" :min="0" v-model="setTravelTime.eSec"></InputNumber>
      </FormItem>
      <FormItem prop="driverName" label="行驶时长">
        <InputNumber :max="14400" :min="0" v-model="setTravelTime.DrvT"></InputNumber>
      </FormItem>
      <FormItem prop="driverName" label="休息时长">
        <InputNumber :max="2400" :min="0" v-model="setTravelTime.RstT"></InputNumber>
      </FormItem>
      <Button type="primary" @click="onCleanDriverCardParams" style="margin-right: 5px;">清空</Button>
      <Button type="primary" @click="onSendDriverCardParams">发送</Button>
    </Form>
  </Modal>
</template>

<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

import MaintainOrderAddMaintainDeviceRecordModal from '@/view/om/components/maintain-order-add-maintain-device-record-modal'

export default {
  name: 'hiksettraveltimemodal',
  components: {

  },
  props: {
    initValue: null,
    terminalNumValue: null,
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      setTravelTime: {
        id: null,
        enabled:false,
        bHour: 22,
        bMin: 0,
        bSec: 0,
        eHour: 6,
        eMin: 0,
        eSec: 0,
        DrvT: 7200,
        RstT: 1200,
      }

    }
  },
  methods: {
    ...mapActions([
      'VehicleInfoServ_SearchByName'
    ]),
    visibleChange (val) {
      if (val) {
        this.setTravelTime.id = this._initValue
        this.setTravelTime.enabled = false
        this.setTravelTime.bHour = 22
        this.setTravelTime.bMin = 0
        this.setTravelTime.bSec = 0
        this.setTravelTime.eHour = 6
        this.setTravelTime.eMin = 0
        this.setTravelTime.eSec = 0
        this.setTravelTime.DrvT = 7200
        this.setTravelTime.RstT = 1200
      }
    },
    onCleanDriverCardParams () {
      this.setTravelTime.enabled = false
      this.setTravelTime.bHour = 22
      this.setTravelTime.bMin = 0
      this.setTravelTime.bSec = 0
      this.setTravelTime.eHour = 6
      this.setTravelTime.eMin = 0
      this.setTravelTime.eSec = 0
      this.setTravelTime.DrvT = 7200
      this.setTravelTime.RstT = 1200
    },
    onSendDriverCardParams () {
      let str= null
      if (this.setTravelTime.enabled) {
      // console.log('N_DRIVE:' + 1  + this.setTravelTime.bHour + ',' + this.setTravelTime.bMin + ',' + this.setTravelTime.bSec + ',' + this.setTravelTime.eHour + ',' + this.setTravelTime.eMin + ',' + this.setTravelTime.eSec + ',' + this.setTravelTime.DrvT + ',' + this.setTravelTime.eSec + ';A')
        str = 'N_DRIVE:' + 1 + ','  + this.setTravelTime.bHour + ',' + this.setTravelTime.bMin + ',' + this.setTravelTime.bSec + ',' + this.setTravelTime.eHour + ',' + this.setTravelTime.eMin + ',' + this.setTravelTime.eSec + ',' + this.setTravelTime.DrvT + ',' + this.setTravelTime.RstT + ';A!!!'
  }else{
        // console.log('N_DRIVE:' + 10 + this.setTravelTime.bHour + ',' + this.setTravelTime.bMin + ',' + this.setTravelTime.bSec + ',' + this.setTravelTime.eHour + ',' + this.setTravelTime.eMin + ',' + this.setTravelTime.eSec + ',' + this.setTravelTime.DrvT + ',' + this.setTravelTime.eSec + ';A')
        str = 'N_DRIVE:' + 0 + ','  + this.setTravelTime.bHour + ',' + this.setTravelTime.bMin + ',' + this.setTravelTime.bSec + ',' + this.setTravelTime.eHour + ',' + this.setTravelTime.eMin + ',' + this.setTravelTime.eSec + ',' + this.setTravelTime.DrvT + ',' + this.setTravelTime.RstT + ';A!!!'
      }
      console.log(str)
      store.dispatch('NetCommandServ_SendCommand', {
        params: { id: this._initValue, content: str , urgent: false }
      }).then(() => {
        this.$Message.success('发送成功')
      }).catch(err => {
        this.$Message.error(err)
      })
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    _terminalNumValue: {
      get () {
        return this.terminalNumValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
